import { Space, Badge } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useReturnCancelCount, useSetReturnCancelCount } from 'hooks/business/openReturnStatus';
import { useInterval } from 'ahooks';

export const ReturnNav = () => {
  const { t } = useTranslate();

  const returnCancelCount = useReturnCancelCount();
  const fetchReturnCancelCount = useSetReturnCancelCount();
  useInterval(
    () => {
      fetchReturnCancelCount();
    },
    15 * 1000,
    { immediate: true },
  );

  return (
    <Space>
      {t('ViewsChat.弃单')}
      <Badge count={returnCancelCount.total} overflowCount={9999} />
    </Space>
  );
};
